<template>
  <div class="caseWrap" id="page8">
    <h2>他们都在用涿溪防窜货</h2>
    <swiper class="mySwiper" ref="mySwiper" :options="swiperOptions">
      <swiper-slide>
        <div class="luanaWrap">
          <div class="leftContent">
            <div class="msg">
              涿溪防窜货是一款一站式全流程防伪营销系统，基于国家标识的名片码、产品码为顾客复购和营销裂变增加了很多场景，涿溪防窜货，真的可以定义新的营销方式。
            </div>
            <div class="name">——周正 潞安娜销售总监</div>
          </div>
          <div class="rightContent">
            <img src="../assets/images/cpl.png" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="luanaWrap">
          <div class="leftContent">
            <div class="msg">
              皙肽的每一件产品都赋予了工信部授权的一物一码标识码，帮助企业进行获客以及精细化运营，从而促进业务增长。通过给皙肽产品赋码，标识码扫码率达到了40%，带来了近15%的复购率增长。
            </div>
            <div class="name">——中国日用化学工业研究院</div>
          </div>
          <div class="rightContent">
            <img src="../assets/images/xtt.png" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="luanaWrap">
          <div class="leftContent">
            <div class="msg">
              BOSS端管理APP解决了多年来数据无法追溯的问题，涿溪防窜货是一股新势力，未来，他可以领航美业防伪营销数据管理一体化。</div>
            <div class="name">——韩冠生物CEO</div>
          </div>
          <div class="rightContent">
            <img src="../assets/images/hg_img.png" />
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide>
        <div class="luanaWrap">
          <div class="leftContent">
            <div class="msg">
              不是所有的防伪码都叫涿溪防窜货，涿溪防窜货现在做的事情在未来1-2年就会被市场认可，我非常看好涿溪防窜货的未来
            </div>
            <div class="name">果冻物联</div>
          </div>
          <div class="rightContent">
          </div>
        </div>
      </swiper-slide> -->
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
    <div class="myPagation">
      <span v-for="(item, index) in dataPagation" :key="item.name" @click="slideTab(index)" :class="{'activePagation': swiperIndex === index}">
        <!-- <img :src="item.img" style="width: 105px;" /> -->
      </span>
    </div>
  </div>

</template>
<script>
//导入swiper
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide, directive } from 'vue-awesome-swiper'
export default {
  name: 'codewhat',
  components: {
    swiper,
    swiperSlide
  },
  directives: {
    swiper: directive
  },
  data () {
    let this_ = this
    return {
      swiperOptions: {
        allowTouchMove: false,
        // autoplay:true,
        pagination: {
          el: '.swiper-pagination',
          paginationClickable: true,
        },
        on:{
          slideChange: function(){
            console.log('改变了，activeIndex为'+this.activeIndex);
            this_.swiperIndex = this.activeIndex
          },
        },
        // Some Swiper option/callback...
      },
      dataPagation:[
        {
          name: '潞安娜',
          // img: require('../assets/images/lan.png'),
        },
        {
          name: '皙肽',
          // img: require('../assets/images/lan.png'),
        },
        {
          name: '韩冠生物',
          // img: require('../assets/images/hg_logo.png'),
        },
        // {
        //   name: '果冻物联',
        //   img: '',
        // }
      ],
      swiperIndex: 0
    }
  },
  methods: {
    slideTab (index) {
      this.swiper.slideTo(index, 1000, false)
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper // important
    }
  },
  mounted () {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }

}
</script>
<style scoped lang="scss">
.caseWrap{
  padding: 60px 100px 0;
  > h2 {
    font-size: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 56px;
    text-align: center;
  }
}
.luanaWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .leftContent{
     width: 60%;
     margin-right: 30px;
    .msg{
      font-size: 28px;
      font-family: FZQKBYSJW--GB1-0, FZQKBYSJW--GB1;
      font-weight: normal;
      color: #3C424C;
      line-height: 58px;
      letter-spacing: 1px;
    }
    .name{
      font-size: 21px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: normal;
      color: #9098A4;
      line-height: 28px;
      text-align: right;
    }
  }

}

/***swiper****/
.mySwiper{
  // width: 90%;
  margin: 0 auto;
  height: 300px;
  // border: 1px solid #f00;
}
  .myPagation{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 60px 0 40px;
    span {
      width: 267px;
      height: 108px;
      overflow: hidden;
      border: 1px solid #f7f7f7;
      border-radius: 20px;
      text-align: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      &:nth-child(1) {
        background: url('../assets/images/lan.png') center center no-repeat;
      }
      &:nth-child(2) {
        background: url('../assets/images/xt_1.png') center center no-repeat;
      }
      &:nth-child(3) {
        background: url('../assets/images/hg_logo.png') center center no-repeat;
      }
      &:hover{
        border: 1px solid #6D3B96;
      }
      &:nth-child(1).activePagation{
        border: 1px solid #6D3B96;
        background-image: url('../assets/images/lan2.png');
      }
      &:nth-child(2).activePagation{
        border: 1px solid #6D3B96;
        background-image: url('../assets/images/xt_2.png');
      }
      &:nth-child(3).activePagation{
        border: 1px solid #6D3B96;
        background-image: url('../assets/images/hg_logo2.png');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CodeCase.vue